"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const react_1 = require("react");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const stepStatus_1 = require("../../stepStatus");
const PathIcon_1 = __importDefault(require("../PathIcon"));
const APP_ICON_SIZE = 40;
const STATUS_ICON_SIZE = 26;
const stepIconCss = {
    alignItems: 'center',
    border: `1px solid ${design_system_1.Colors.grey300}`,
    borderRadius: 8,
    display: 'flex',
    height: 60,
    padding: '0 10px',
    position: 'relative',
    width: 'min-content',
};
const statusIconCss = {
    backgroundColor: design_system_1.Colors.white,
    borderRadius: STATUS_ICON_SIZE,
    height: STATUS_ICON_SIZE,
    left: -STATUS_ICON_SIZE / 3,
    position: 'absolute',
    top: -STATUS_ICON_SIZE / 4,
    width: STATUS_ICON_SIZE,
};
const StepLogo = ({ api, pathInfo }) => {
    if (pathInfo) {
        return core_1.jsx(PathIcon_1.default, Object.assign({}, pathInfo, { size: "mega" }));
    }
    if (api) {
        return core_1.jsx(common_components_1.LogoImage, { app: api, border: false, size: APP_ICON_SIZE });
    }
    return (core_1.jsx(design_system_1.Icon, { color: "grey200", isBlock: true, name: "miscBolt", size: APP_ICON_SIZE }));
};
const dividerCss = {
    borderRight: `1px solid ${design_system_1.Colors.grey300}`,
    height: '100%',
    margin: '0 10px',
};
const PathAndStepLogo = ({ api, parentPathInfo }) => (core_1.jsx(react_1.Fragment, null,
    core_1.jsx(PathIcon_1.default, Object.assign({}, parentPathInfo, { size: "mega" })),
    core_1.jsx("div", { css: dividerCss }),
    core_1.jsx(StepLogo, { api: api })));
const hasStatusIcon = (status) => stepStatus_1.isStepComplete(status) || stepStatus_1.isStepInError(status);
const StepIcon = ({ api, parentPathInfo, pathInfo, status }) => (core_1.jsx("div", { css: stepIconCss },
    hasStatusIcon(status) && (core_1.jsx("div", { css: statusIconCss },
        stepStatus_1.isStepComplete(status) && (core_1.jsx("div", { "aria-label": "success checkmark" },
            core_1.jsx(design_system_1.Icon, { color: "green500", isBlock: true, name: "formCheckCircle", size: STATUS_ICON_SIZE }))),
        stepStatus_1.isStepInError(status) && (core_1.jsx("div", { "aria-label": "alert icon" },
            core_1.jsx(design_system_1.Icon, { color: "grey500", isBlock: true, name: "alertCircle", size: STATUS_ICON_SIZE }))))),
    parentPathInfo ? (core_1.jsx(PathAndStepLogo, { api: api, parentPathInfo: parentPathInfo })) : (core_1.jsx(StepLogo, { api: api, pathInfo: pathInfo }))));
StepIcon.defaultProps = {
    status: 'incomplete',
};
const FastStepIcon = react_1.memo(StepIcon);
exports.default = FastStepIcon;
